import React from 'react'
import {
    Button,
    Input,
    Tabs,
    Modal,
    Spin,
    Checkbox,
    Divider,
    message,
} from 'antd'
import classnames from 'classnames'
import AddCardForm from '../../Billing/AddCardForm'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import SecureLockIcon from '../../../assets/img/security-lock.png'

import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { refresh_profile } from '../../../actions/auth'

import './styles.scss'

const validate = (field, rule) => {
    console.log(field)
    const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return rule === 'email'
        ? field !== undefined && !emailRegex.test(field)
        : field !== undefined && field.length === 0
}

const FilebaseTabs = ({ onTabChange, activeWasabiTab, ...props }) => (
    <div className="add-wasabi-tabs">
        <Tabs
            onChange={onTabChange}
            type="card"
            animated={true}
            activeKey={activeWasabiTab}>
            <Tabs.TabPane tab="On-board existing account" key="add">
                <CreateWasabi {...props} />
            </Tabs.TabPane>
            {/* <Tabs.TabPane tab="Provision new account" key="create">
                <AddWasabi {...props} />
            </Tabs.TabPane> */}
        </Tabs>
    </div>
)

const CreateWasabi = ({
    disabledSave,
    edit,
    setupForm,
    loading,
    on_save,
    on_input_change,
}) => (
    <div className={'add-wasabi'}>
        <h3>On-board existing account</h3>
        <div className="input-area">
            <div>
                <label>Access Key*</label>
                <Input
                    placeholder="Enter Access Key"
                    name="access_key_id"
                    value={setupForm.access_key_id}
                    disabled={edit}
                    className={classnames({
                        required: validate(setupForm.access_key_id),
                    })}
                    onChange={on_input_change}
                />
                {validate(setupForm.access_key_id) && (
                    <span className="required">Access Key is required.</span>
                )}
            </div>
            <div>
                <label>Secret Key*</label>
                <Input
                    type={edit ? 'password' : 'text'}
                    placeholder="Enter Secret Key"
                    name="secret_access_key"
                    value={setupForm.secret_access_key}
                    disabled={edit}
                    className={classnames({
                        required: validate(setupForm.secret_access_key),
                    })}
                    onChange={on_input_change}
                />
                {validate(setupForm.secret_access_key) && (
                    <span className="required">Secret Key is required.</span>
                )}
            </div>
            <div>
                <label>Give it a name</label>
                <Input
                    placeholder="Enter Account Name"
                    name="project_name"
                    value={setupForm.project_name}
                    className={classnames({
                        required: validate(setupForm.project_name),
                    })}
                    onChange={on_input_change}
                />
                {validate(setupForm.project_name) && (
                    <span className="required">
                        It's always good to give a name to your cloud service,
                        so you can organize them better.
                    </span>
                )}
            </div>
        </div>

        <div className="footer">
            <Button
                type="primary"
                disabled={disabledSave}
                loading={loading}
                onClick={on_save}>
                Apply
            </Button>
        </div>
    </div>
)

class AddWasabi extends React.Component {
    constructor(props) {
        super(props)

        this.state = { saveClicked: false }
    }

    handleClick = () => {
        this.setState({saveClicked: true})
    }

    render() {
        const {
            disabledSave,
            edit,
            setupForm,
            loading,
            on_save,
            on_input_change,
            user,
            history,
            refresh_profile,
        } = this.props
        const { saveClicked } = this.state
        return (
            <div className={'add-wasabi'}>
                {saveClicked && (
                    <ConfirmModal
                        user={user}
                        history={history}
                        refresh_profile={refresh_profile}
                        onConfirm={on_save}
                    />
                )}
                <div>
                    <div>
                        <label>Email*</label>
                        <Input
                            placeholder="enter email"
                            name="email"
                            value={setupForm.email}
                            disabled={edit}
                            className={classnames({
                                required: validate(setupForm.email, 'email'),
                            })}
                            onChange={on_input_change}
                        />
                        {validate(setupForm.email, 'email') && (
                            <span className="required">
                                Enter a valid email.
                            </span>
                        )}
                    </div>
                    <div>
                        <label>Password*</label>
                        <Input
                            type={'password'}
                            placeholder="enter password"
                            name="password"
                            value={setupForm.password}
                            disabled={edit}
                            className={classnames({
                                required: validate(setupForm.password),
                            })}
                            onChange={on_input_change}
                        />
                        {validate(setupForm.password) && (
                            <span className="required">
                                Password is required.
                            </span>
                        )}
                    </div>
                    <div>
                        <label>Account Name*</label>
                        <Input
                            placeholder="enter account name"
                            name="project_name"
                            value={setupForm.project_name}
                            disabled={edit}
                            className={classnames({
                                required: validate(setupForm.project_name),
                            })}
                            onChange={on_input_change}
                        />
                        {validate(setupForm.project_name) && (
                            <span className="required">
                                Account name is required.
                            </span>
                        )}
                    </div>
                </div>
                <div className="footer">
                    <Button
                        type="primary"
                        disabled={disabledSave}
                        loading={loading}
                        onClick={this.handleClick}>
                        Save and Connect
                    </Button>
                </div>
            </div>
        )
    }
}

class ConfirmModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            togglePrice: false,
            confirmed: false,
            addCardVisible: false,
            loading: false,
            visible: false,
            cc: {
                firstName: '',
                lastName: '',
                number: '',
                expiry: '',
                cvc: '',
                focused: 'number',
                valid: false,
            },
        }
    }

    componentDidMount() {
        const { is_cbs, confirmed_wasabi } = this.props.user.organization
        const visible = !is_cbs && !confirmed_wasabi
        this.setState({ visible })
        if (!visible) {
            this.props.onConfirm()
        }
    }

    confirm = () => {
        const { cc } = this.state
        const {
            user: { has_billing_info },
        } = this.props

        this.setState({ loading: true })

        if (!has_billing_info) {
            CloudFlyerAPI.billing
                .addCreditCard({
                    full_number: cc.number,
                    first_name: cc.firstName,
                    last_name: cc.lastName,
                    expiration_month: cc.expiry.slice(0, 2),
                    expiration_year: cc.expiry.slice(2, 4),
                    billing_address: '',
                    billing_city: '',
                    billing_state: '',
                    billing_country: '',
                    billing_zip: '',
                })
                .then(res => {
                    message.success('Credit Card Added Successfully')
                    this.setState({ visible: false, loading: false })
                    this.updateFlag('wasabi', true)
                    this.props.onConfirm()
                })
                .catch(res => message.error('Could not add Credit Card'))
        } else {
            this.updateFlag('wasabi', true)
            this.setState({ visible: false })
            this.props.onConfirm()
        }
    }

    updateFlag = (flag, value) => {
        CloudFlyerAPI.user_account
            .setConfirmedFlags({ [`confirmed_${flag}`]: value })
            .then(() => {
                this.props.refresh_profile(true)
                this.setState({ loading: false })
            })
    }

    handleCCFocus = target => {
        this.setState({
            cc: {
                ...this.state.cc,
                focused:
                    target.name === 'firstName' || target.name === 'lastName'
                        ? 'name'
                        : target.name,
            },
        })
    }

    handleCCChange = target => {
        const cc = { ...this.state.cc }

        if (target.name === 'number') {
            cc[target.name] = target.value.replace(/ /g, '')
        } else if (target.name === 'expiry') {
            cc[target.name] = target.value.replace(/[ \/]/g, '')
        } else {
            cc[target.name] = target.value
        }

        this.setState({ cc })
    }

    ccCallback = (type, isValid) => {
        this.setState({
            cc: {
                ...this.state.cc,
                valid: isValid,
            },
        })
    }

    handleConfirm = () => {
        const { period } = this.state
        const {
            user: { has_billing_info },
        } = this.props
        if (has_billing_info) {
            this.confirm()
        } else {
            this.setState({ addCardVisible: true, confirmed: true })
        }
    }

    handleCheckConfirm = e => {
        const newState = { ...this.state }
        newState['confirmed'] = e.target.checked
        if (!e.target.checked) {
            newState['addCardVisible'] = false
        }
        this.setState(newState)
    }

    handleCancel = () => {
        const { history } = this.props
        this.setState({ visible: false })
        history.push('/')
    }

    onTogglePrice = () => {
        this.setState({togglePrice: !this.state.togglePrice})
    }

    render() {
        const { confirmed, cc, addCardVisible, loading, visible, togglePrice } = this.state
        return (
            <Modal
                className="confirm-modal"
                wrapClassName="wrap-confirm-modal"
                visible={visible}
                width={700}
                onCancel={this.handleCancel}
                footer={
                    addCardVisible && (
                        <div className="footer-msg">
                            <p>
                                Once you add your card, it will be charged the
                                agreed upon amount and will be saved.
                            </p>
                            <p>
                                You will always receive a confirmation email
                                following any transaction.
                            </p>
                            <div className="secure-form-txt">
                                <img
                                    alt="secure lock icon"
                                    src={SecureLockIcon}
                                />
                                &nbsp; Secure Form
                            </div>
                        </div>
                    )
                }>
                <Spin spinning={loading}>
                    <h1>Start using Wasabi Storage</h1>
                    <p>
                        Begin using Wasabi Cloud Storage immediately by
                        confirming the billing information below.
                        <br />
                        Your account will be charged monthly.
                        <br />
                    </p>
                    <div className="buttons">
                        <Button type="primary" size="large" onClick={this.onTogglePrice}>
                            {togglePrice ? "$.0059 per GB/Month" : "$5.99 per TB/Month"}
                        </Button>
                    </div>
                    <div className="confirm-checkbox">
                        <Checkbox
                            onChange={this.handleCheckConfirm}
                            checked={confirmed}>
                            i acknowledge my account will be charged
                            $.0059/GB/Month for Wasabi Storage and will reflect
                            in my CloudFlyer invoice.
                        </Checkbox>
                    </div>
                    <div className="confirm-container">
                        <Button
                            disabled={!confirmed || addCardVisible}
                            size="large"
                            type="primary"
                            onClick={this.handleConfirm}>
                            Confirm
                        </Button>
                    </div>
                    {addCardVisible && (
                        <div>
                            <Divider>
                                <h3>Add Credit Card</h3>
                            </Divider>
                            <AddCardForm
                                loading={false}
                                on_save={this.confirm}
                                on_cancel={() => console.log('canceling ..')}
                                name={cc.name}
                                number={cc.number}
                                expiry={cc.expiry}
                                cvc={cc.cvc}
                                focused={cc.focused}
                                callback={this.ccCallback}
                                on_focus={this.handleCCFocus}
                                on_change={this.handleCCChange}
                                valid={cc.valid}
                                cardPosition="none"
                            />
                        </div>
                    )}
                </Spin>
            </Modal>
        )
    }
}

export default withRouter(
    connect(
        state => {
            return {
                user: ((state || {}).auth || {}).user,
            }
        },
        dispatch =>
            bindActionCreators(
                {
                    refresh_profile,
                    dispatch,
                },
                dispatch
            )
    )(FilebaseTabs)
)
